import { inject, Injectable } from '@angular/core';
import {
  ProductServoPipelineResultDto,
  PublicServoElektronikApiService,
  PublicServoElektronikContractCreateDto,
  ServoElektronikVersicherungspraemieCalcDto
} from '@base/backend';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ElektronikService {
  private readonly publicServoElektronikApiService = inject(PublicServoElektronikApiService);

  public getPremium(price: number): Observable<number | null> {
    const dto: ServoElektronikVersicherungspraemieCalcDto = {
      kaufpreisInEur: price
    };

    return this.publicServoElektronikApiService
      .apiPublicServoElektronikContractElektronikVersicherungspraemiePost(dto).pipe(
        map(calculationResult => calculationResult.versicherungspraemieInEur || null),
        catchError(() => {
          return of(null);
        })
      );
  }

  submitElektronikContract(dto: PublicServoElektronikContractCreateDto): Observable<ProductServoPipelineResultDto> {
    return this.publicServoElektronikApiService
      .apiPublicServoElektronikContractElektronikPost(dto);
  }
}
